import bem from 'utils/bem';

export const block = bem('font-family-selector-v2');
